import { LandingPage } from "./pages/LandingPage";
import { WorkspacePage } from "./pages/WorkspacePage";
import { usePagesStore } from "./store/pagesStore";
export default function App() {
  const hasPages = usePagesStore((s) => s.pages.length > 0);
  return hasPages ? <WorkspacePage /> : <LandingPage />;
}
